import React, {useState} from 'react'
import CSRF from 'js/components/CSRF'

import {
  AlignItems,
  AppWrapper,
  ButtonType,
  CTAButton,
  ComponentColor,
  ComponentSize,
  ComponentStatus,
  FlexBox,
  FlexDirection,
  FunnelPage,
  Heading,
  HeadingElement,
  InfluxColors,
  JustifyContent,
  Panel,
} from '@influxdata/clockface'

import LogoWithCubo from 'js/components/LogoWithCubo'

import {ProvisioningError} from '../Notifications/ProvisioningError'

interface Props {
  companyName: string
  hasError: boolean // We only handle one type of error on this page for now
  provider: string
  region: string
}

const FailedProvisioning = ({
  companyName,
  hasError,
  provider,
  region,
}: Props): JSX.Element => {
  const [buttonStatus, updateStatus] = useState<ComponentStatus>(
    ComponentStatus.Default
  )

  const handleSubmit = () => {
    updateStatus(ComponentStatus.Loading)
  }

  return (
    <AppWrapper type="funnel">
      <FunnelPage enableGraphic={true} logo={<LogoWithCubo />}>
        <FlexBox
          alignItems={AlignItems.Center}
          justifyContent={JustifyContent.Center}
          direction={FlexDirection.Column}
        >
          <div style={{height: '10em'}} />
          <form
            action="/orgs/retry"
            data-testid="splash-form"
            method="POST"
            onSubmit={handleSubmit}
          >
            <CSRF />
            <Panel backgroundColor={InfluxColors.Grey25}>
              {hasError && (
                <ProvisioningError
                  style={{
                    position: 'absolute',
                    top: '-95px',
                  }}
                />
              )}
              <Panel.Header size={ComponentSize.Large}>
                <Heading element={HeadingElement.H2}>
                  Uh-oh, we hit a snag!
                </Heading>
              </Panel.Header>
              <Panel.Body>
                <FlexBox
                  alignItems={AlignItems.FlexStart}
                  direction={FlexDirection.Column}
                  justifyContent={JustifyContent.FlexStart}
                  margin={ComponentSize.Large}
                >
                  <Heading element={HeadingElement.H4}>
                    There were some issues setting up your environment. Please
                    try again.
                  </Heading>
                  <div>Cloud Provider: {provider}</div>
                  <div>Region: {region}</div>
                  <div>Company Name: {companyName}</div>
                </FlexBox>
              </Panel.Body>
            </Panel>
            <FlexBox
              alignItems={AlignItems.FlexEnd}
              direction={FlexDirection.Column}
              justifyContent={JustifyContent.Center}
              style={{marginTop: '63px'}}
            >
              <CTAButton
                className="splash-error--cta-button"
                color={ComponentColor.Primary}
                status={buttonStatus}
                text="Try Again"
                type={ButtonType.Submit}
              />
            </FlexBox>
          </form>
        </FlexBox>
      </FunnelPage>
    </AppWrapper>
  )
}

export default FailedProvisioning
